<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-avatar src="/logo.png" />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Reset | Farmbusiness
          </b-card-title>
          <b-card-text class="mb-2">
            Please enter your account email
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginValidation"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="resetPassword"
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="accountEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="daniel@farmbusinessapp.org"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                <div class=""></div>
                  <b-link :to="{name:'login'}">
                    <small>Back to Login?</small>
                  </b-link>
                </div>
              </b-form-group>

              <!-- submit buttons -->
              <div class="float-right">
                <am-button
                  label="Request Password Reset"
                  :disabled="invalid"
                  :loading="reseting"
                  @click="resetPassword()"
                />
              </div>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BAvatar,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store'
import AmButton from '@/farmbusiness/components/AmButton'
import showToast from '@/farmbusiness/mixins/showToast'

export default {
  components: {
    AmButton,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BAvatar,
  },
  mixins: [togglePasswordVisibility, showToast],
  data() {
    return {
      accountEmail: null,
      sideImg: require('@/assets/images/pages/login/side.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      reseting: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login/side.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    resetPassword() {
      this.reseting = true
      this.$store.dispatch('auth/requestReset', {email: this.accountEmail}).then(res => {
        this.showSuccess('You will receive an email if your email exist.')
        this.$router.push({name: 'login'})
      }).catch((err)=>{
        this.showError("Something went wrong")
      }).finally(() => {
        this.reseting = false
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
